import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATES } from "@/lib/catalog";

export const StateSelect = ({ value, onChange, testId, className = "" }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className={`h-12 rounded-xl ${className}`}>
      <SelectValue placeholder="Choose state / territory" />
    </SelectTrigger>
    <SelectContent className="z-[200]">
      {STATES.map(([code, name]) => (
        <SelectItem key={code} value={code} data-testid={`${testId}-${code}`}>
          {code} — {name}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
